import { Controller } from '@hotwired/stimulus';
import { sendAlert } from './noti_controller';
import callApi, { callApiWithoutBody } from '../common/AjaxUtil';

export default class extends Controller {
  static targets = ['text', 'comment', 'form', 'edit', 'editText', 'sort', 'guest', 'anonymous'];

  static values = {
    id: Number,
    userId: Number,
    issueId: Number,
    parentId: Number,
    status: String,
    statsId: String,
    promoted: Boolean,
    isSuspended: Boolean,
  };

  connect() {
    if (this.hasSortTarget) {
      this.sortTarget.addEventListener('change', this.onSortChange.bind(this));
    }
    if (this.hasTextTarget) {
      this.textTarget.addEventListener('focus', this.onTextFocus.bind(this));
    }
  }

  disconnect() {
    if (this.hasSortTarget) {
      this.sortTarget.removeEventListener('change', this.onSortChange.bind(this));
    }
    if (this.hasTextTarget) {
      this.textTarget.removeEventListener('focus', this.onTextFocus.bind(this));
    }
  }

  onSortChange(e) {
    location = window.location.pathname + this.replaceQueryParam('cmt_sort', e.target.value, window.location.search);
  }

  onTextFocus() {
    if (this.isSuspendedValue) {
      location.href = '/denied/suspend';
      return;
    }
    if (this.hasGuestTarget) {
      location.href = '/denied/guest';
      return;
    }
    if (this.hasAnonymousTarget) {
      location.href = '/login';
    }
  }

  clear() {
    this.textTarget.value = '';
  }

  create() {
    const comment = {
      userId: this.userIdValue,
      issueId: this.issueIdValue,
      content: this.textTarget.value,
      statsId: this.statsIdValue,
      parentId: this.hasParentIdValue ? this.parentIdValue : null,
    };

    if (comment.content.trim() === '') {
      sendAlert('댓글 내용을 입력해주세요');
      return;
    }

    callApi('/ajax/comments', 'POST', comment)
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$sendAlert(err.msg);
      });
  }

  async edit() {
    const comment = {
      id: this.idValue,
      content: this.editTextTarget.value,
    };

    callApi(`/ajax/comments/${this.idValue}`, 'PUT', comment)
      .then(() => location.reload())
      .catch((err) => {
        window.$sendAlert(err.msg);
      });
  }

  async delete() {
    if (confirm('삭제하시겠습니까?')) {
      callApiWithoutBody(`/ajax/comments/${this.idValue}`, 'DELETE')
        .then(() => location.reload())
        .catch((err) => {
          window.$sendAlert(err.msg);
        });
    }
  }

  toggleForm() {
    if (this.formTarget.classList.contains('hidden')) {
      this.formTarget.classList.remove('hidden');
    } else {
      this.formTarget.classList.add('hidden');
    }
  }

  toggleEdit() {
    if (this.editTarget.classList.contains('hidden')) {
      this.editTarget.classList.remove('hidden');
      this.commentTarget.classList.add('hidden');
    } else {
      this.editTarget.classList.add('hidden');
      this.commentTarget.classList.remove('hidden');
    }
  }

  async toggleBlock() {
    if (this.statusValue === 'BLOCK') {
      if (confirm('댓글을 숨김해제 하겠습니까?')) {
        callApiWithoutBody(`/ajax/comments/${this.idValue}/open`, 'POST')
          .then(() => location.reload())
          .catch((err) => {
            window.$sendAlert(err.msg);
          });
      }
    } else {
      if (confirm('댓글을 숨기겠습니까?')) {
        callApiWithoutBody(`/ajax/comments/${this.idValue}/block`, 'POST')
          .then(() => location.reload())
          .catch((err) => {
            window.$sendAlert(err.msg);
          });
      }
    }
  }

  async togglePromote() {
    if (!this.promotedValue) {
      callApiWithoutBody(`/ajax/comments/${this.idValue}/promote`, 'POST')
        .then(() => location.reload())
        .catch((err) => {
          window.$sendAlert(err.msg);
        });
    } else {
      callApiWithoutBody(`/ajax/comments/${this.idValue}/unpromote`, 'POST')
        .then(() => location.reload())
        .catch((err) => {
          window.$sendAlert(err.msg);
        });
    }
  }

  more(e) {
    e.preventDefault();
    const increase = 10;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params['cmt_size']) {
      location =
        window.location.pathname +
        this.replaceQueryParam('cmt_size', parseInt(params['cmt_size']) + 10, window.location.search);
    } else {
      location =
        window.location.pathname +
        window.location.search +
        `${window.location.search ? '&' : '?'}` +
        `cmt_size=${increase * 2}`;
    }
  }

  replaceQueryParam(param, newval, search) {
    var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
    var query = search.replace(regex, '$1').replace(/&$/, '');

    return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
  }
}
